<template>
  <div class="about">
    <div class="pc">
      <div class="banner">
        <img src="img/zbj.png" alt="" />
        <div class="mask">
          <div class="box">About Kenta</div>
        </div>
      </div>
      <h3 class="title">About US</h3>
      <div class="module1">
        <div class="box">
          <div class="content">
            <div>
              <h4>
                Vision
                <br />
                <br />
                <p class="line"></p>
                <br />
              </h4>
              <p>
                To be our customers' most reliable and responsive <br />
                supplier,to grow our business through technology and <br />
                ingenuity, and to deliver leading-edge solutions with top <br />
                quality while keeping integrity and ethics standards.
              </p>
            </div>
            <div>
              <h4>
                Mission
                <br />
                <br />
                <p class="line"></p>
                <br />
              </h4>
              <p>
                Be a century-long leading injection molding manufacturer <br />
                that provides sense of happiness and pride to all <br />
                shareholders.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="module2">
        <img src="img/cl.jpg" alt="" />
      </div>
      <!-- <div class="module3">
        <div class="box">
          <h3>Milestone</h3>
          <el-carousel height="150px" indicator-position="none">
            <el-carousel-item
              v-for="(item, index) in this.list"
              :key="index"
              @change="
                (pre, next) => {
                  change(pre);
                }
              "
            >
              <div class="box3">
                <div class="top">
                  <img :src="item.ming" alt="" /><img src="" alt="" />
                </div>
                <div class="bottom">
                  <h3>{{ item.时间 }}</h3>
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div> -->
      <div class="module4">
        <h4>Corporate Social Responsibility (CSR)</h4>
        <h5>
          At Kenta, our commitment to corporate social responsibility (CSR), it
          is integral to our <br />
          corporate culture. We recognize the importance of running our business
          to create <br />
          economic value and social value for our employees and the communities
          in which we <br />
          work, and to help preserve the planet for future generations.Kenta
          strives to expand the <br />
          scope of its social engagement initiatives.
        </h5>
        <p>
          Charitable donations have been made to the education sector in China,
          because we believe that every child should <br />
          deserve an education regardless of their household living
          standard.More than 20 Hope Schools have already been built <br />
          since 2007.Kenta is going to continuously donate to the Hope Project
          as a means of repaying the community. <br />
          <br />
          <br /><br />
          Global environmental protection is one of the main area Kenta
          concerned.To achieve the production and products are in <br />
          environmental friendly, Kenta considers different aspects,like
          product's design, transportation, packaging and <br />
          manufacturing.We advise our clients of the ideas, solutions and skills
          before starting the production lifecycle. In <br />
          production, the reduction of waste and pollution, recycling and
          upcycling are controlled and supervised. Kenta strives to <br />
          meet the requirement from customers, government, markets.
        </p>
      </div>
      <div class="module5">
        <h4>Sustainability</h4>
        <div class="content2">
          <div>
            <img src="img/earth.png" alt="" />
            <h5>Environmental Friendly</h5>
            <span></span>
            <p>
              Kenta considers different <br />
              aspects,like product's design, <br />
              transportation, packaging and <br />
              manufacturing.
            </p>
          </div>
          <div>
            <img src="img/zero-emission 1.png" alt="" />
            <h5>Reduce Emission</h5>
            <span></span>
            <p>
              ln production, we insist on <br />
              selecting tools, production <br />
              processes, materials and <br />
              production equipment that are <br />
              less harmful to the environment.
            </p>
          </div>
          <div>
            <img src="img/user 1.png" alt="" />
            <h5>Staff Training</h5>
            <span></span>
            <p>
              lmprove the environmental <br />
              awareness of all employees of <br />
              the company
            </p>
          </div>
          <div>
            <img src="img/world 1.png" alt="" />
            <h5>Reduce Waste</h5>
            <span></span>
            <p>
              Materials will be recycled as <br />
              much as possible to reduce the <br />
              amount of materials used, so as <br />
              to reduce the amount of waste <br />
              generated and reduce pollution.
            </p>
          </div>
          <div>
            <img src="img/shield 1.png" alt="" />
            <h5>Law and Regulations</h5>
            <span></span>
            <p>
              Evaluate the status of the <br />
              company and its compliance with <br />
              environmental laws and <br />
              regulations
            </p>
          </div>
          <div>
            <img src="img/light-bulb 1.png" alt="" />
            <h5>environmental laws and</h5>
            <span></span>
            <p>
              Take effective actions to actively <br />
              participate in the work of <br />
              environmental protection.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          ming: "img/l1.png",
          时间: "1985",
          content: "Kenta Enterprise Ltd Co. was founded in Hong Kong.",
        },
        {
          ming: "img/l2.png",
          时间: "1991",
          content:
            "The first factory was established in Dong Guan, Guang Dong,targeting at the market in traditional transformers.",
        },
        {
          ming: "img/l3.png",
          时间: "1998",
          content:
            "Dong Guan factory was awarded ISO 9001 certificate & UL accreditation.The factory developed a new market in SMD transformers.A new factory complex was established in Dong",
        },
        {
          ming: "img/l4.png",
          时间: "2000",
          content:
            "A new factory complex was established in Dong Guan.The factory developed a new market in automotive products and began to develop and manufacture igniters for Ford.",
        },
        {
          ming: "img/l5.png",
          时间: "2001",
          content:
            "The company stepped into the market in network and connector products.",
        },
        {
          ming: "img/l6.png",
          时间: "2003",
          content:
            "The company was awarded Sony GP and ISO 14000 certificates. The company started to build a new and larger factory complex in Kun Shan, Jiangsu.",
        },

        {
          ming: "img/l7.png",
          时间: "2005",
          content:
            "Kun Shan Factory was established to focus on developing and manufacturing automotive products.",
        },
        {
          ming: "img/l8.png",
          时间: "2006",
          content:
            "Kun Shan Factory obtained UL & ISO certifications.Dong Guan Factory obtained ISO TS16949 certification.",
        },
        {
          ming: "img/l9.png",
          时间: "2008",
          content:
            "Kun Shan Factory was awarded ISO 14000 & TS 16949 certifications. Dong Guan Factory was qualified as a second tier supplier for Volkswagen and BMW.",
        },
        {
          ming: "img/l1.png",
          时间: "1985",
          content: "Kenta Enterprise Ltd Co. was founded in Hong Kong.",
        },
        {
          ming: "img/l1.png",
          时间: "1985",
          content: "Kenta Enterprise Ltd Co. was founded in Hong Kong.",
        },
        {
          ming: "img/l1.png",
          时间: "1985",
          content: "Kenta Enterprise Ltd Co. was founded in Hong Kong.",
        },
        {
          ming: "img/l1.png",
          时间: "1985",
          content: "Kenta Enterprise Ltd Co. was founded in Hong Kong.",
        },
      ],
    };
  },
  mounted() {
    document.getElementsByClassName("el-carousel__item").forEach((item) => {
      item.style.backgroundColor = "white";
    });
    document.getElementsByClassName(
      "el-carousel__item"
    )[0].style.backgroundColor = "gray";
  },
  methods: {
    change(index) {
      document.getElementsByClassName("el-carousel__item").forEach((item) => {
        item.style.backgroundColor = "white";
      });
      document.getElementsByClassName("el-carousel__item")[
        index
      ].style.backgroundColor = "gray";
    },
  },
};
</script>
<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 50%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }
  .line {
    width: 2.5vw;
    height: 0.15vw;
    background: red;
  }
  > h3 {
    width: 70%;
    margin: 3vw auto;
    font-size: 2vw;
  }

  .box {
    width: 70%;
    margin: 0 auto;
  }
  .module1 {
    width: 100%;
    height: 18vw;
    .content {
      display: flex;
      > div {
        padding-left: 10%;
        h4 {
          font-size: 1.2vw;
        }
        width: 50%;
        p {
          color: grey;
          font-size: 0.8vw;
        }
      }
    }
  }
  .module2 {
    width: 100%;
    overflow: hidden;
    height: 30vw;
    img {
      width: 100%;
      position: relative;
      top: -50%;
    }
  }
  .module3 {
    width: 100%;
    background: white;
    .box {
      margin: 0 auto;
      .el-carousel-item {
        box-sizing: border-box;
        padding: 2vw;
      }
      .box3 {
        .top {
          background: white;
          height: 15vw;
          overflow: hidden;
          text-align: center;
        }
        .bottom {
          box-sizing: border-box;
          padding: 2vw;
        }
      }
      img {
        width: 50%;
      }
    }
  }
  .module4 {
    width: 65%;
    margin: auto;
    h4 {
      font-size: 2vw;
      margin: 2vw 0;
    }
    h5 {
      width: 100%;
      font-size: 1vw;
      letter-spacing: 0.1vw;
    }
    p {
      color: gray;
      margin: 2vw 0;
    }
  }
  .module5 {
    background: white;
    > h4 {
      width: 80%;
      margin: auto;
      font-size: 2vw;
      box-sizing: border-box;
      padding: 4vw 0vw 1vw 6vw;
    }
    .content2 {
      padding: 5vw;
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      > div {
        width: 33%;
        text-align: center;
        margin-top: 2vw;
        h5 {
          font-size: 1.2vw;
        }
        img {
          width: 5vw;
          margin: 1vw 0;
        }
        p {
          color: gray;
          font-size: 0.9vw;
        }
      }
    }
  }
}
</style>
